import Payment from "./views/Payment.js";
import PaymentResult from "./views/PaymentResult.js";
import Inquiry from "./views/Inquiry.js";
import Rules from "./views/Rules.js";
import Help from "./views/Help.js";
import AboutUs from "./views/AboutUs.js";
import ContactUs from "./views/ContactUs.js";
import Complaint from "./views/Complaint.js";
import Questions from "./views/Questions.js";

var routes = [
  {
    path: "/payment/Result/:Code?/:ResNum?",
    component: PaymentResult
  },
  {
    path: "/payment/:ai?/:am?/:vi?",
    Navpath: "/payment",
    rtlName: "صفحه پرداخت",
    icon: "tim-icons icon-chart-pie-36",
    component: Payment
  },

  {
    path: "/inquiry",
    Navpath: "/inquiry",
    rtlName: "پیگیری پرداخت",
    icon: "tim-icons icon-atom",
    component: Inquiry
  },
  {
    path: "/rules",
    Navpath: "/rules",
    rtlName: "قوانین و مقررات",
    icon: "tim-icons icon-pin",
    component: Rules
  },
  {
    path: "/help",
    Navpath: "/help",
    rtlName: "راهنمای سامانه",
    icon: "tim-icons icon-bell-55",
    component: Help
  },
  {
    path: "/aboutus",
    Navpath: "/aboutus",
    rtlName: "درباره ما",
    icon: "tim-icons icon-single-02",
    component: AboutUs
  },
  {
    path: "/contactus",
    Navpath: "/contactus",
    rtlName: "تماس با ما",
    icon: "tim-icons icon-puzzle-10",
    component: ContactUs
  },
  {
    path: "/complaint",
    Navpath: "/complaint",
    rtlName: "شکایات",
    icon: "tim-icons icon-align-center",
    component: Complaint
  },
  {
    path: "/questions",
    Navpath: "/questions",
    rtlName: "سوالات متداول",
    icon: "tim-icons icon-world",
    component: Questions
  },
  {
    path: "/pay?{am}",
    component: Questions
  },
  
];
export default routes;
